import React from 'react';

import SellerPresetsHotkey from '../seller-presets';
import ToggleQuickship from './toggle-quickship';

const orderBatchesGridHotkeys = [SellerPresetsHotkey, ToggleQuickship];

const OrderBatchesGridHotkeys = ({ children, ...props }) => {
  return orderBatchesGridHotkeys.reduce((acc, Hotkey) => <Hotkey {...props}>{acc}</Hotkey>, children);
};

export default OrderBatchesGridHotkeys;
